

import {
  OPEN_DIALOG,
  CLOSE_DIALOG,
  SET_DIALOG_DATA,
  CLEAR_DIALOG_DATA,
  UPDATE_DIALOG_DATA
} from "types/actions/dialogs"
import Deferred from "promise-deferred"

const dialogPromises = {}

export const _openDialog = name => ({
  type: OPEN_DIALOG,
  name
})

export const _closeDialog = name => ({
  type: CLOSE_DIALOG,
  name
})

export const setDialogData = (name, data = {}) => ({
  type: SET_DIALOG_DATA,
  name,
  data
})

export const updateDialogData = (name, data = {}) => ({
  type: UPDATE_DIALOG_DATA,
  name,
  data
})

export const clearDialogData = name => ({
  type: CLEAR_DIALOG_DATA,
  name
})

export const openDialog = (name, data) => {
  return dispatch => {
    dispatch(setDialogData(name, data))
    setTimeout(() => {
      dispatch(_openDialog(name))
    }, 150)
    dialogPromises[name] = new Deferred()
    return dialogPromises[name].promise
  }
}

export const closeDialog = (name, state) => {
  if (state === "success") {
    dialogPromises[name].resolve(state)
  } else {
    dialogPromises[name].resolve(state)
  }
  return dispatch => {
    dispatch(_closeDialog(name))
    setTimeout(() => {
      dispatch(clearDialogData(name))
    }, 300)
  }
}
